import { currentLang, pick, type Lang } from "@kit/lang";

const strings = {
  title: { tr: "Zaman Çizgisi", en: "Timeline" },
  back: { tr: "‹ Oyunlar", en: "‹ Games" },
  level: { tr: "SEVİYE", en: "LEVEL" },
  status: { tr: "Kart {moves}/{total} · Hata {mistakes}", en: "Card {moves}/{total} · Mistake {mistakes}" },
  prompt: { tr: "Bu olay nereye?", en: "Where does this go?" },
  anchor: { tr: "Başlangıç olayı", en: "Anchor event" },
  categories: {
    tr: { history: "Tarih", science: "Bilim", space: "Uzay", sports: "Spor", art: "Sanat", turkey: "Türkiye" },
    en: { history: "History", science: "Science", space: "Space", sports: "Sports", art: "Arts", turkey: "Türkiye" },
  },
  wonTitle: { tr: "Harika sıraladın!", en: "Timeline mastered!" },
  lostTitle: { tr: "Bir daha dene", en: "Try again" },
  retry: { tr: "Tekrar dene", en: "Retry for free" },
  skip: { tr: "Atla", en: "Skip" },
  next: { tr: "Sonraki seviye", en: "Next level" },
  share: { tr: "Paylaş", en: "Share" },
  noMistakes: { tr: "Hatasız kronoloji", en: "Flawless timeline" },
  mistakeCount: { tr: "{moves} kart · {mistakes} hata", en: "{moves} cards · {mistakes} mistakes" },
  lossDetail: { tr: "Tüm kartları yerleştirdin. Ücretsiz tekrar edebilirsin.", en: "You placed every card. Retry whenever you like." },
  levelWin: { tr: "Seviye {level} tamamlandı", en: "Level {level} complete" },
  levelLost: { tr: "Bu turda yeterli yıldız çıkmadı.", en: "Not enough stars this run." },
  plusOne: { tr: "+1", en: "+1" },
  categoryLine: { tr: "{category} · yılını tahmin et", en: "{category} · place its year" },
  reminder: { tr: "Eski yıllar yukarıda · yeni yıllar aşağıda", en: "Older years above · newer years below" },
  stars: { tr: "{stars} yıldız", en: "{stars} stars" },
} as const;

export type ZamanString = keyof typeof strings;

export function language(): Lang {
  return currentLang();
}

export function tr(key: ZamanString): string {
  return pick(currentLang(), strings[key] as { tr: string; en: string });
}

export function categoryText(category: keyof typeof strings.categories.tr): string {
  return pick(currentLang(), { tr: strings.categories.tr[category], en: strings.categories.en[category] });
}

export function formatText(key: ZamanString, values: Record<string, string | number> = {}): string {
  return tr(key).replace(/\{(\w+)\}/g, (_match, name: string) => String(values[name] ?? ""));
}
